// 网站内容 mock 数据：作品、分类、榜单、专题、口碑、FAQ
// 数据源说明：当前为静态内容承载，后续可接入后台替换。

export interface Category {
  id: string;
  name: string;
  desc: string;
  count: number;
  image: string;
}

export interface Work {
  id: string;
  title: string;
  genre: string;
  rating: number;
  votes: number;
  year: string;
  tags: string[];
  desc: string;
  image: string;
}

export interface Roundup {
  id: string;
  title: string;
  tag: string;
  desc: string;
  count: number;
  image: string;
}

export interface Review {
  id: string;
  user: string;
  work: string;
  rating: number;
  content: string;
  date: string;
  helpful: number;
}

export interface Faq {
  q: string;
  a: string;
}

export const siteName = "还得是人妻动漫";
export const siteTagline = "同好口碑 · 人气排行 · 每期精选";
export const contactEmail = "hello@renqidm.example";

// ---------- 分类 ----------
export const categories: Category[] = [
  {
    id: "hu-hou-lian-ai",
    name: "婚后恋爱",
    desc: "聚焦婚姻里的心动与成长，温暖细腻的恋爱故事。",
    count: 46,
    image:
      "https://readdy.ai/api/search-image?query=warm%20romantic%20anime%20illustration%20of%20a%20tender%20couple%20holding%20hands%20under%20blooming%20cherry%20branches%2C%20soft%20terracotta%20and%20cream%20tones%2C%20cozy%20domestic%20scene%2C%20storybook%20style%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=cat-houhoulianai&orientation=landscape",
  },
  {
    id: "jia-ting-sheng-huo",
    name: "家庭日常",
    desc: "一日三餐、柴米油盐里的温柔，治愈你的每个瞬间。",
    count: 38,
    image:
      "https://readdy.ai/api/search-image?query=warm%20anime%20illustration%20of%20a%20cozy%20family%20kitchen%20scene%20with%20warm%20morning%20light%2C%20a%20couple%20cooking%20breakfast%20together%2C%20soft%20terracotta%20and%20cream%20tone%2C%20domestic%20slice%20of%20life%2C%20storybook%20style%2C%20high%20detail&width=600&height=400&seq=cat-jiatingrichang&orientation=landscape",
  },
  {
    id: "zhi-chang-hun-yin",
    name: "职场婚姻",
    desc: "事业与家庭的平衡，成年人的世界同样动人。",
    count: 29,
    image:
      "https://readdy.ai/api/search-image?query=warm%20anime%20illustration%20of%20a%20professional%20couple%20sharing%20a%20quiet%20moment%20at%20a%20city%20window%20at%20dusk%2C%20soft%20terracotta%20and%20amber%20tones%2C%20modern%20office%20romance%2C%20storybook%20style%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=cat-zhichanghunyin&orientation=landscape",
  },
  {
    id: "zhi-yu-wen-qing",
    name: "治愈温情",
    desc: "缓慢而绵长的治愈故事，给生活留一点甜。",
    count: 33,
    image:
      "https://readdy.ai/api/search-image?query=warm%20soothing%20anime%20illustration%20of%20a%20peaceful%20home%20porch%20with%20a%20couple%20sipping%20tea%20under%20soft%20afternoon%20sun%2C%20cream%20and%20warm%20muted%20terracotta%20palette%2C%20healing%20slice%20of%20life%2C%20storybook%20style%2C%20high%20detail&width=600&height=400&seq=cat-zhiyuwenqing&orientation=landscape",
  },
  {
    id: "gu-feng-hun-lian",
    name: "古风婚恋",
    desc: "旧时光里的婚约与深情，东方美学下的浪漫。",
    count: 22,
    image:
      "https://readdy.ai/api/search-image?query=warm%20eastern%20style%20anime%20illustration%20of%20a%20couple%20in%20traditional%20chinese%20attire%20walking%20through%20a%20lantern%20lit%20old%20street%2C%20terracotta%20red%20and%20gold%20tone%2C%20antique%20romance%2C%20storybook%20style%2C%20soft%20lighting%2C%20high%20detail&width=600&height=400&seq=cat-gufenghunlian&orientation=landscape",
  },
  {
    id: "xuan-yi-hun-yin",
    name: "悬疑婚姻",
    desc: "在平静表面下暗流涌动，情感与悬念交织。",
    count: 17,
    image:
      "https://readdy.ai/api/search-image?query=moody%20warm%20anime%20illustration%20of%20a%20mysterious%20quiet%20living%20room%20with%20a%20silhouetted%20couple%20by%20dim%20warm%20lamplight%2C%20deep%20terracotta%20and%20amber%20tones%2C%20suspenseful%20romance%2C%20storybook%20style%2C%20high%20detail&width=600&height=400&seq=cat-xuanyihunyin&orientation=landscape",
  },
];

// ---------- 作品（推荐 + 榜单共用） ----------
export const works: Work[] = [
  {
    id: "hun-hou-tong-ju",
    title: "婚后同居手账",
    genre: "婚后恋爱 · 治愈",
    rating: 9.4,
    votes: 12860,
    year: "2025",
    tags: ["新婚", "日常", "治愈"],
    desc: "记录一对新人在同一屋檐下的琐碎与温柔，把平淡日子过成闪着光的样子。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20romantic%20anime%20cover%20illustration%20of%20a%20happy%20newlywed%20couple%20in%20a%20cozy%20bright%20apartment%20living%20room%2C%20soft%20terracotta%20and%20cream%20tone%2C%20tender%20smile%2C%20storybook%20style%2C%20portrait%20composition%2C%20soft%20lighting%2C%20high%20detail&width=600&height=800&seq=work-hunhoutongju&orientation=portrait",
  },
  {
    id: "shen-ye-chu-fang",
    title: "深夜厨房的守护",
    genre: "家庭日常 · 温情",
    rating: 9.1,
    votes: 9840,
    year: "2024",
    tags: ["美食", "家庭", "温情"],
    desc: "妻子每晚在厨房为晚归的丈夫点亮一盏灯，一碗热汤里藏着说不出口的爱。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20anime%20cover%20illustration%20of%20a%20woman%20cooking%20in%20a%20cozy%20warm%20kitchen%20at%20night%20with%20soft%20lamp%20glow%2C%20terracotta%20and%20cream%20tone%2C%20domestic%20slice%20of%20life%2C%20storybook%20style%2C%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=work-shenyechufang&orientation=portrait",
  },
  {
    id: "zhi-zi-zhi-shou",
    title: "执子之手",
    genre: "古风婚恋 · 情深",
    rating: 9.2,
    votes: 11230,
    year: "2023",
    tags: ["古风", "婚约", "深情"],
    desc: "一纸婚约牵起两段人生，旧街灯火里写尽举案齐眉与细水长流。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20eastern%20anime%20cover%20illustration%20of%20a%20couple%20in%20traditional%20chinese%20attire%20under%20glowing%20lanterns%2C%20terracotta%20red%20and%20gold%20tone%2C%20antique%20romance%2C%20storybook%20style%2C%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=work-zhizizhishou&orientation=portrait",
  },
  {
    id: "chen-hun-zhi-jian",
    title: "晨昏之间",
    genre: "职场婚姻 · 成长",
    rating: 8.9,
    votes: 8620,
    year: "2025",
    tags: ["职场", "成长", "都市"],
    desc: "在通勤与加班的缝隙里，他们学着把『我们』放进每天的生活清单。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20anime%20cover%20illustration%20of%20a%20couple%20sharing%20coffee%20on%20a%20rooftop%20terrace%20at%20sunrise%20in%20the%20city%2C%20amber%20and%20terracotta%20tone%2C%20modern%20romance%2C%20storybook%20style%2C%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=work-chenhunzhijian&orientation=portrait",
  },
  {
    id: "jiu-jie-qin-sheng",
    title: "旧街的琴声",
    genre: "复古浪漫 · 治愈",
    rating: 9.0,
    votes: 7410,
    year: "2022",
    tags: ["复古", "音乐", "治愈"],
    desc: "老巷尽头的琴行里，一场重逢让两个人在岁月中重新认识彼此。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20nostalgic%20anime%20cover%20illustration%20of%20a%20couple%20at%20an%20old%20street%20music%20shop%20with%20warm%20window%20light%2C%20cream%20and%20terracotta%20tone%2C%20retro%20romance%2C%20storybook%20style%2C%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=work-jiujieqinsheng&orientation=portrait",
  },
  {
    id: "nian-lun",
    title: "年轮",
    genre: "成长 · 婚姻",
    rating: 8.8,
    votes: 6980,
    year: "2024",
    tags: ["成长", "现实", "温情"],
    desc: "用一棵树的年轮讲述一段婚姻的四季，接纳彼此的不完美才是相爱。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20melancholic%20anime%20cover%20illustration%20of%20a%20couple%20under%20a%20large%20old%20tree%20in%20autumn%20sunlight%2C%20muted%20terracotta%20and%20amber%20tones%2C%20emotional%20romance%2C%20storybook%20style%2C%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=work-nianlun&orientation=portrait",
  },
  {
    id: "wu-yan-xia-de-chun",
    title: "屋檐下的春天",
    genre: "治愈温情 · 日常",
    rating: 9.3,
    votes: 10540,
    year: "2025",
    tags: ["治愈", "四季", "家庭"],
    desc: "一栋老屋、一院子花，从春天到冬天，他们重新学会认真生活。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20soothing%20anime%20cover%20illustration%20of%20a%20couple%20gardening%20in%20a%20sunny%20old%20house%20courtyard%20full%20of%20blooming%20flowers%2C%20cream%20and%20soft%20terracotta%20tone%2C%20healing%20slice%20of%20life%2C%20storybook%20style%2C%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=work-wuyanxiadechun&orientation=portrait",
  },
  {
    id: "mu-se-gui-tu",
    title: "暮色归途",
    genre: "悬疑婚姻 · 情感",
    rating: 8.7,
    votes: 6240,
    year: "2023",
    tags: ["悬疑", "情感", "反转"],
    desc: "一个寻常傍晚的回家路上，隐藏多年的秘密开始一点点浮出水面。",
    image:
      "https://readdy.ai/api/search-image?query=moody%20warm%20anime%20cover%20illustration%20of%20a%20couple%20walking%20home%20on%20a%20dim%20dusk%20street%20with%20amber%20streetlights%2C%20deep%20terracotta%20tones%2C%20suspenseful%20romance%2C%20storybook%20style%2C%20portrait%20composition%2C%20high%20detail&width=600&height=800&seq=work-musegui-tu&orientation=portrait",
  },
];

// ---------- 人气排行榜 ----------
export interface RankItem {
  rank: number;
  title: string;
  genre: string;
  score: number;
  trend: "up" | "down" | "keep";
  year: string;
}

export const ranking: RankItem[] = [
  { rank: 1, title: "婚后同居手账", genre: "婚后恋爱 · 治愈", score: 9.4, trend: "up", year: "2025" },
  { rank: 2, title: "屋檐下的春天", genre: "治愈温情 · 日常", score: 9.3, trend: "up", year: "2025" },
  { rank: 3, title: "执子之手", genre: "古风婚恋 · 情深", score: 9.2, trend: "keep", year: "2023" },
  { rank: 4, title: "深夜厨房的守护", genre: "家庭日常 · 温情", score: 9.1, trend: "up", year: "2024" },
  { rank: 5, title: "旧街的琴声", genre: "复古浪漫 · 治愈", score: 9.0, trend: "down", year: "2022" },
  { rank: 6, title: "晨昏之间", genre: "职场婚姻 · 成长", score: 8.9, trend: "up", year: "2025" },
  { rank: 7, title: "年轮", genre: "成长 · 婚姻", score: 8.8, trend: "keep", year: "2024" },
  { rank: 8, title: "暮色归途", genre: "悬疑婚姻 · 情感", score: 8.7, trend: "down", year: "2023" },
];

// ---------- 专题盘点 ----------
export const roundups: Roundup[] = [
  {
    id: "zhi-yu-top10",
    title: "婚后治愈系 TOP 10 盘点",
    tag: "人气专题",
    desc: "从柴米油盐到四季三餐，盘点最治愈人心的婚后日常作品，每一部都能抚平一天的疲惫。",
    count: 10,
    image:
      "https://readdy.ai/api/search-image?query=warm%20soothing%20anime%20illustration%20of%20a%20cozy%20sunlit%20living%20room%20with%20soft%20blankets%20and%20tea%20mugs%2C%20cream%20and%20terracotta%20palette%2C%20healing%20domestic%20scene%2C%20storybook%20style%2C%20soft%20lighting%2C%20high%20detail&width=800&height=500&seq=round-zhiyutop10&orientation=landscape",
  },
  {
    id: "xin-shou-rug-keng",
    title: "新手入坑：从这 5 部开始",
    tag: "入坑指南",
    desc: "刚接触这个题材不知从哪看起？按情感浓度和上手难度排序，帮你找到最合适的第一部。",
    count: 5,
    image:
      "https://readdy.ai/api/search-image?query=warm%20welcoming%20anime%20illustration%20of%20a%20cute%20guide%20scene%20with%20open%20book%20and%20cozy%20reading%20corner%2C%20cream%20and%20soft%20terracotta%20tones%2C%20beginner%20friendly%20mood%2C%20storybook%20style%2C%20high%20detail&width=800&height=500&seq=round-xinshourukeng&orientation=landscape",
  },
  {
    id: "nian-du-ren-qi",
    title: "年度人气口碑榜",
    tag: "年度盘点",
    desc: "综合评分、口碑与讨论热度，回顾这一年同好心中真正的年度之作，不掺水的真实榜单。",
    count: 12,
    image:
      "https://readdy.ai/api/search-image?query=warm%20celebration%20anime%20illustration%20of%20a%20trophy%20and%20ribbon%20on%20a%20cozy%20wooden%20table%20with%20confetti%2C%20amber%20and%20terracotta%20tones%2C%20yearly%20award%20mood%2C%20storybook%20style%2C%20high%20detail&width=800&height=500&seq=round-niandurenqi&orientation=landscape",
  },
];

// ---------- 同好口碑 ----------
export const reviews: Review[] = [
  {
    id: "r1",
    user: "午后红茶",
    work: "婚后同居手账",
    rating: 5,
    content:
      "看完整个人都被治愈了，那种把平淡日子过出光来的感觉太戳我了，配乐也很温柔，推荐给所有喜欢婚后日常的朋友。",
    date: "2026.08.12",
    helpful: 328,
  },
  {
    id: "r2",
    user: "常青藤",
    work: "执子之手",
    rating: 5,
    content:
      "古风题材里少见的细腻，画面和配乐都在线，感情线很稳，没有刻意煽情，看完会让人很想好好经营一段关系。",
    date: "2026.08.09",
    helpful: 214,
  },
  {
    id: "r3",
    user: "小满",
    work: "深夜厨房的守护",
    rating: 4,
    content:
      "每一集的宵夜都看得我口水直流，但更打动我的是那种不需要言语的陪伴，很真实的婚姻关系描写。",
    date: "2026.08.05",
    helpful: 176,
  },
  {
    id: "r4",
    user: "南屿",
    work: "晨昏之间",
    rating: 4,
    content:
      "职场与婚姻双线并行，很多片段都像在看自己。节奏不算快，但后劲很足，适合静下心来慢慢看。",
    date: "2026.07.28",
    helpful: 143,
  },
  {
    id: "r5",
    user: "山茶",
    work: "屋檐下的春天",
    rating: 5,
    content:
      "从春天到冬天拍了一整年，每一帧都像画一样。看完最大的感受是：幸福也可以很慢、很简单。",
    date: "2026.07.20",
    helpful: 261,
  },
  {
    id: "r6",
    user: "北屿来信",
    work: "暮色归途",
    rating: 4,
    content:
      "反转让人意想不到，情感线和悬疑线平衡得很好，不是单纯卖梗，是真正在讲一段关系的裂痕与修复。",
    date: "2026.07.15",
    helpful: 98,
  },
];

// ---------- 常见问题 ----------
export const faqs: Faq[] = [
  {
    q: "什么是人妻动漫？",
    a: "人妻动漫是指以已婚女性为主要角色、围绕婚姻关系展开的动漫作品题材，涵盖婚后恋爱、家庭日常、职场婚姻、治愈温情等多种细分方向。本站聚焦这类题材，帮助同好快速发现优质作品。",
  },
  {
    q: "网站是如何挑选和推荐作品的？",
    a: "我们综合作品的剧情质量、画面制作、情感表达与同好口碑等多维度进行筛选，并结合社区讨论热度与真实评价动态更新，优先推荐真正经得起推敲、值得一看的作品。",
  },
  {
    q: "排行榜多久更新一次？",
    a: "人气排行榜每期定期更新，评分与口碑数据会根据同好评价持续校正。年度口碑榜则在每年年终发布，汇总全年表现与社区反馈。",
  },
  {
    q: "这些作品是否适合所有人观看？",
    a: "本站推荐的作品以温情治愈、日常成长类为主，题材温和。不过不同作品的风格与接受度不同，建议结合每部作品的分级与简介判断是否适合自己观看。",
  },
  {
    q: "如何提交作品推荐或反馈错误？",
    a: "如果你有想推荐的作品或发现信息有误，欢迎通过页脚的联系邮箱与我们反馈。我们会认真阅读每一条建议，并纳入后续推荐与校正。",
  },
  {
    q: "网站是作品的官方制作方吗？",
    a: "不是。本站是独立的内容推荐与口碑平台，仅做作品介绍与推荐，不参与任何作品的制作、发行或授权，版权归各原版权方所有。",
  },
];